export default "/_next/static/images/alexander-jeremiah-b11df5268cc913f2147da954ccd832fc.png";